import { Trans } from "@lingui/react/macro";
import type {
  MemoPanelMemo,
  UserMemoFeatureKind,
} from "../layout/memo-panel-types";
import type { UserMemoContext } from "../layout/workspace-side-panel-mode";

/**
 * feature 単位の公開範囲を、ユーザーが選んだ機能名込みの文言で表示します。
 * 汎用的な「この機能」ではなく、将来の UA / IW 展開でも意味が伝わる label に寄せます。
 */
export function featurePublicationScopeLabel(featureKind: UserMemoFeatureKind) {
  switch (featureKind) {
    case "DASHBOARD":
      return <Trans>All dashboards</Trans>;
    case "INDEX_WORKER":
      return <Trans>Entire Index Worker</Trans>;
    case "USER_ANALYTICS":
      return <Trans>Entire User Analytics</Trans>;
    case "SEARCH_ANALYTICS":
      return <Trans>Entire Search Analytics</Trans>;
  }
}

/**
 * VIEW scope の表示名を、実際に閉じる対象に合わせます。
 * 内部値は VIEW のまま保ちつつ、Dashboard では「view」ではなく dashboard の範囲として伝えます。
 */
function viewPublicationScopeLabel(
  featureKind: UserMemoFeatureKind,
  _targetKind?: UserMemoContext["targetKind"],
) {
  switch (featureKind) {
    case "DASHBOARD":
      return <Trans>This dashboard only</Trans>;
    case "INDEX_WORKER":
      return <Trans>This Index Worker only</Trans>;
    case "USER_ANALYTICS":
    case "SEARCH_ANALYTICS":
      return <Trans>This view only</Trans>;
  }
}

/**
 * memo badge と filter / form option で使う公開範囲 label を統一します。
 * memo 自身の featureKind が欠ける場合は現行 SA の label に倒します。
 */
export function publicationScopeLabel(
  scope: MemoPanelMemo["publicationScope"],
  featureKind: MemoPanelMemo["featureKind"] = "SEARCH_ANALYTICS",
  targetKind?: UserMemoContext["targetKind"],
) {
  switch (scope) {
    case "VIEW":
      return viewPublicationScopeLabel(
        featureKind ?? "SEARCH_ANALYTICS",
        targetKind,
      );
    case "WORKSPACE":
      return <Trans>Entire workspace</Trans>;
    case "FEATURE":
      return featurePublicationScopeLabel(featureKind ?? "SEARCH_ANALYTICS");
    case "PROJECT":
      return <Trans>This project only</Trans>;
  }
}
